import Button from 'components/base/Button';
import Rating from 'components/base/Rating';
import { Form, Modal } from 'react-bootstrap';
import Dropzone from 'components/base/Dropzone';
import {
  addProductReview,
  Product,
  ProductReview
} from 'api/products/_requests';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { StringDecoder } from 'string_decoder';
import { addBrandReview, BrandReview } from 'api/categories/_requests';
interface ReviewModalProps {
  show: boolean;
  handleClose: () => void;
  brandId: string | null;
}

const BrandReviewModal = ({ show, handleClose, brandId }: ReviewModalProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [rating, setRating] = useState<number>(0);
  const [reviewText, setReviewText] = useState('');

  const onSubmit = async () => {
    if (rating < 1 || rating > 5) {
      toast.error('Please select a valid rating between 1 and 5');
      setIsSubmitting(false);
      return;
    }

    setIsSubmitting(true);
    try {
      const reviewData: BrandReview = {
        brand: brandId || '',
        rating: rating,
        review: reviewText || ''
      };

      await addBrandReview(reviewData);
      toast.success('Thank you for your feedback.');
      setReviewText('');
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      handleClose();
    } catch (error) {
      toast.error('Failed to send Feedback.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <div className="p-4">
        <div className="d-flex flex-between-center mb-3">
          <h5 className="fs-8 mb-0">Your rating</h5>
          <button className="btn p-0 fs-10" onClick={handleClose}>
            Clear
          </button>
        </div>

        <Rating
          emptyIconColor="warning"
          iconClass="fs-5"
          className="mb-3"
          onClick={rate => setRating(Math.round(rate))}
          initialValue={rating * 20}
        />
        <div className="mb-3">
          <h5 className="text-body-highlight mb-3">Your review</h5>
          <Form.Control
            as="textarea"
            rows={5}
            value={reviewText}
            onChange={e => setReviewText(e.target.value)}
          />
        </div>
        <div className="d-sm-flex flex-between-center">
          <Form.Check type="checkbox" id="confirmCheck" className="flex-1">
            {/* <Form.Check.Input type="checkbox" defaultChecked />
                            <Form.Check.Label className="text-body-emphasis">
                            Review anonymously
                            </Form.Check.Label> */}
          </Form.Check>
          <button className="btn ps-0" onClick={handleClose}>
            Close
          </button>
          <Button
            variant="primary"
            className="rounded-pill"
            onClick={onSubmit}
            disabled={isSubmitting}
          >
            Submit
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default BrandReviewModal;
